import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';
import { WorkingDayOrderBuilder } from '../../models/builders/working-day-order.builder';
import { valueOf } from '../../utils/string.utils';
import { WorkingDayOrder } from '../../models/working-day-order';
import { getUserLogged } from '../../utils/jwt.utils';

const getWorkingDayOrderBody = (workingDayOrder: WorkingDayOrder) => ({
  user: (workingDayOrder.userHash) ? workingDayOrder.userHash : getUserLogged(),
  workingShiftHash: workingDayOrder.workingShiftHash,
  information: workingDayOrder.information,
  date: workingDayOrder.date,
});

@Injectable()
export class WorkingDayOrderApiService {
  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${environment.apiUrl}workingDayOrders`;
  }

  createWorkingDayOrder(workingDayOrder: WorkingDayOrder) {
    return this.httpClient.post(this.apiUrl, getWorkingDayOrderBody(workingDayOrder))
      .pipe(map(WorkingDayOrderBuilder.fromJson));
  }

  updateWorkingDayOrder(workingDayOrder: WorkingDayOrder) {
    return this.httpClient.put(`${this.apiUrl}/${workingDayOrder.hash}`, getWorkingDayOrderBody(workingDayOrder))
      .pipe(map(WorkingDayOrderBuilder.fromJson));
  }

  getWorkingDayOrder(start: number, end: number) {
    const params = new HttpParams()
      .append('start', valueOf(start))
      .append('end', valueOf(end));

    return this.httpClient.get(`${this.apiUrl}/by-user`, { params })
      .pipe(map(WorkingDayOrderBuilder.fromJson));
  }

  getWorkingDayOrders(start: number, end: number) {
    const params = new HttpParams()
      .append('start', valueOf(start))
      .append('end', valueOf(end));

    return this.httpClient.get(`${this.apiUrl}`, { params })
      .pipe(map(WorkingDayOrderBuilder.fromList));
  }

  getWorkingDayOrderByWorkingHourValidation(hash: string) {
    return this.httpClient.get(`${this.apiUrl}/by-validation/${hash}`, {})
      .pipe(map(WorkingDayOrderBuilder.fromJson));
  }

  validateWorkingDayOrder(workingDayOrder: WorkingDayOrder) {
    return this.httpClient.post(`${ this.apiUrl }/${ workingDayOrder.hash }/validate`, {});
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/working-day-order-api.service.ts